"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _react = _interopRequireWildcard(require("react"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _immutable = require("immutable");

var _classnames = _interopRequireDefault(require("classnames"));

var _PropertyOptionRecord = _interopRequireDefault(require("customer-data-objects/property/PropertyOptionRecord"));

var _ReferenceInputEnum = _interopRequireDefault(require("customer-data-reference-ui-components/ReferenceInputEnum"));

var propTypes = {
  autoFocus: _react.PropTypes.bool,
  className: _react.PropTypes.string,
  onChange: _react.PropTypes.func.isRequired,
  value: _react.PropTypes.string
};
var noValueToken = 'NO_VALUE';

var PropertyInputPersona =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(PropertyInputPersona, _React$Component);

  function PropertyInputPersona() {
    var _this;

    (0, _classCallCheck2.default)(this, PropertyInputPersona);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PropertyInputPersona).call(this));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.focus = _this.focus.bind((0, _assertThisInitialized2.default)(_this));
    _this._input = null;
    return _this;
  }

  (0, _createClass2.default)(PropertyInputPersona, [{
    key: "focus",
    value: function focus(evt) {
      this._input.focus(evt);
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var noValue = _I18n.default.text('customerDataProperties.PersonaSearchableSelectInput.noPersona');

      var blankValueOption = (0, _PropertyOptionRecord.default)({
        label: noValue,
        value: noValueToken
      });
      return _immutable.List.of(blankValueOption);
    }
  }, {
    key: "handleChange",
    value: function handleChange(evt) {
      var value = evt.target.value;
      var nextValue = value === noValueToken ? '' : "" + value;
      return this.props.onChange({
        target: {
          value: nextValue
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["className"]);
      var value = this.props.value ? this.props.value.toString() : undefined;
      return _react.default.createElement(_ReferenceInputEnum.default, (0, _extends2.default)({}, rest, {
        className: (0, _classnames.default)('PropertyInputPersona', className),
        onChange: this.handleChange,
        options: this.getOptions(),
        ref: function ref(input) {
          _this2._input = input;
        },
        value: value
      }));
    }
  }]);
  return PropertyInputPersona;
}(_react.default.Component);

exports.default = PropertyInputPersona;
PropertyInputPersona.propTypes = propTypes;
module.exports = exports.default;